import axios from "axios";
import * as types from "../mutation-types";
import api from "../../api/api";

export const state = {
  overTimeRequests: [],
  listOverTimeRequest: [],
  overTimeRequestApproval: [],
  overTimeRequest: {},
  commonProjects: [],
  employeeOverTimeRequests: [],
  employeeOverTimeRequest: {},
  employeeOverTimeInfo: [],
  projectsEmployees: [],
  approvalPersons: [],
  pagination: {
    from: 0,
    to: 0,
    totalPage: 0,
    path: "",
    currentPage: 0,
    totalRecord: 0,
    perPage: 0
  },
  totalOverTimeRequest: {}
};

// getters
export const getters = {
  overTimeRequests: state => state.overTimeRequests,
  listOverTimeRequest: state => state.listOverTimeRequest,
  overTimeRequestApproval: state => state.overTimeRequestApproval,
  commonProjects: state => state.commonProjects,
  overTimeRequest: state => state.overTimeRequest,
  employeeOverTimeRequests: state => state.employeeOverTimeRequests,
  employeeOverTimeRequest: state => state.employeeOverTimeRequest,
  employeeOverTimeInfo: state => state.employeeOverTimeInfo,
  projectsEmployees: state => state.projectsEmployees,
  pagination: state => state.pagination,
  approvalPersons: state => state.approvalPersons,
  totalOverTimeRequest: state => state.totalOverTimeRequest,
};

// mutations
export const mutations = {
  [types.OVERTIME_REQUEST.FETCH_OVERTIME_REQUEST](state, data) {
    state.overTimeRequests = data.overTimeRequests;
    state.pagination.from = data.overTimeRequests.from;
    state.pagination.to = data.overTimeRequests.to;
    state.pagination.totalPage = data.overTimeRequests.last_page;
    state.pagination.path = data.overTimeRequests.path;
    state.pagination.currentPage = data.overTimeRequests.current_page;
    state.pagination.totalRecord = data.overTimeRequests.total;
    state.pagination.perPage = data.overTimeRequests.per_page;
    state.totalOverTimeRequest = data.totalOverTimeRequest
  },
  [types.OVERTIME_REQUEST.FETCH_OVERTIME_REQUEST_APPROVAL](
    state,
    data
  ) {
    state.overTimeRequestApproval = data.overTimeRequests;
    state.pagination.from = data.overTimeRequests.from;
    state.pagination.to = data.overTimeRequests.to;
    state.pagination.totalPage = data.overTimeRequests.last_page;
    state.pagination.path = data.overTimeRequests.path;
    state.pagination.currentPage = data.overTimeRequests.current_page;
    state.pagination.totalRecord = data.overTimeRequests.total;
    state.pagination.perPage = data.overTimeRequests.per_page;
    state.totalOverTimeRequest = data.totalOverTimeRequest
  },
  [types.OVERTIME_REQUEST.SHOW_OVERTIME_REQUEST](state, overTimeRequest) {
    state.overTimeRequest = overTimeRequest;
  },
  [types.OVERTIME_REQUEST.LIST_OVERTIME_REQUEST_ALL_APPROVAL](
    state,
    listOverTimeRequest
  ) {
    state.listOverTimeRequest = listOverTimeRequest;
  },
  [types.OVERTIME_REQUEST.COMMON_PROJECT](state, commonProjects) {
    state.commonProjects = commonProjects;
  },
  [types.OVERTIME_REQUEST.SHOW_OVER_TIME_REQUEST_APPROVAL](state, employee) {
    state.employeeOverTimeRequest = employee;
  },
  [types.OVERTIME_REQUEST.GET_INFO_OVER_TIME](state, res) {
    state.employeeOverTimeInfo = res;
  },
  [types.OVERTIME_REQUEST.GET_PROJECTS_EMPLOYEES_OVER_TIME](state, res) {
    state.projectsEmployees = res;
  },
  [types.OVERTIME_REQUEST.GET_APPROVAL_PERSON](state, res) {
    state.approvalPersons = res;
  }
};

// actions
export const actions = {
  async listOverTimeRequest({
    commit
  }, payload) {
    const response = await axios.get(api.LIST_OVERTIME_REQUEST, {
      params: {
        // per_page: payload.optionPage,
        page: payload.currentPage,
        // start_date: payload.start_date,
        // end_date: payload.end_date,
        // project_id: payload.projectId,
        approve_person: payload.approvePerson,
        status: payload.status,
        sort_column: payload.sortColumn,
        sort_by: payload.sortBy,
        month: payload.month
      }
    });
    commit(
      types.OVERTIME_REQUEST.FETCH_OVERTIME_REQUEST,
      response.data
    );
    commit(types.OVERTIME_REQUEST.COMMON_PROJECT, response.data.commonProjects);
  },

  async listOverTimeRequestApproval({
    commit
  }, payload) {
    const response = await axios.get(api.LIST_OVERTIME_REQUEST_APPROVAL, {
      params: {
        // per_page: payload.optionPage,
        page: payload.currentPage,
        employee_info: payload.employeeInfo,
        position_id: payload.positionId,
        division_code: payload.divisionCode,
        // start_date: payload.start_date,
        // end_date: payload.end_date,
        // project_id: payload.projectId,
        status: payload.status,
        sort_column: payload.sortColumn,
        sort_by: payload.sortBy,
        month: payload.month,
        approveStatus: payload.approveStatus
      }
    });
    commit(
      types.OVERTIME_REQUEST.FETCH_OVERTIME_REQUEST_APPROVAL,
      response.data
    );
    commit(
      types.OVERTIME_REQUEST.LIST_OVERTIME_REQUEST_ALL_APPROVAL,
      response.data.listOverTimeRequest
    );
    commit(types.OVERTIME_REQUEST.COMMON_PROJECT, response.data.commonProjects);
  },

  async detailOverTimeRequest({
    commit
  }, overTimeRequestId) {
    const response = await axios.get(
      api.SHOW_OVERTIME_REQUEST + "/" + overTimeRequestId
    );
    commit(types.OVERTIME_REQUEST.SHOW_OVERTIME_REQUEST, response.data);
  },

  // eslint-disable-next-line
  deleteOverTimeRequest(_, overTimeRequestId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(api.DELETE_OVER_TIME_REQUEST + "/" + overTimeRequestId)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  async showEmployeeOverTimeRequest({
    commit
  }, overTimeRequestId) {
    const response = await axios
      .get(api.SHOW_OVER_TIME_REQUEST_APPROVAL + "/" + overTimeRequestId)
      .catch(e => console.log(e));
    if (response) {
      commit(
        types.OVERTIME_REQUEST.SHOW_OVER_TIME_REQUEST_APPROVAL,
        response.data
      );
    }
  },

  // eslint-disable-next-line
  async createOverTime(_, params) {
    await axios.post(api.CREATE_OVER_TIME, params);
  },

  async getInfoOverTime({
    commit
  }, params) {
    let url = `${api.GET_INFO_OVER_TIME}/${params}/edit`;
    const response = await axios
      .get(url)
      .then(res => res)
      .catch(error => {
        return error.response;
      });
    if (response.status == 200) {
      commit(types.OVERTIME_REQUEST.GET_INFO_OVER_TIME, response.data);
    }
  },

  // eslint-disable-next-line
  async updateOverTime(_, params) {
    let url = `${api.UPDATE_OVER_TIME}/${params.over_time_request_id}`;
    await axios.post(url, params);
  },

  // eslint-disable-next-line
  async getProjectEmployee({
    commit
  }) {
    let url = `${api.GET_PROJECTS_EMPLOYEES_OVER_TIME}`;
    const response = await axios
      .get(url)
      .then(res => res)
      .catch(error => {
        return error.response;
      });
    if (response.status == 200) {
      commit(
        types.OVERTIME_REQUEST.GET_PROJECTS_EMPLOYEES_OVER_TIME,
        response.data
      );
    }
  },

  // eslint-disable-next-line
  async getApprovalPerson({
    commit
  }) {
    let url = `${api.GET_APPROVAL_PERSON}`;
    const response = await axios
      .get(url)
      .then(res => res)
      .catch(error => {
        return error.response;
      });
    if (response.status == 200) {
      commit(types.OVERTIME_REQUEST.GET_APPROVAL_PERSON, response.data);
    }
  },

  // eslint-disable-next-line
  async approvalOverTime(_, params) {
    let url = `${api.APPROVE_OVER_TIME}/${params.id}`;
    await axios.post(url, params.data);
  },

  // eslint-disable-next-line
  async approvalListOverTime(_, params) {
    let url = `${api.APPROVE_LIST_OVER_TIME}`;
    await axios.post(url, params);
  }
};
